import Tooltip from './Tooltip';

export default Tooltip;


//////////////////
// WEBPACK FOOTER
// ./node_modules/rc-tooltip/es/index.js
// module id = 613
// module chunks = 0 1